<template lang="pug">
  v-container(class="pa-15")
    v-dialog(v-if="selectedSubCat" persistent  :value='createItemDialog'  max-width='500px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        v-card(style="border: solid;border-color: black;border-width: 1px;")
          v-card-title(style="margin-bottom: 22px;")
            | {{isCreate ? 'Crear': 'Actualizar'}} Subcategoria
            v-spacer
              v-icon(aria-label="Close" @click="createItemDialog = false")
                | mdi-close
          v-card-text.body-1.text-center
            v-row
              v-col(cols="12" md="12")
                v-snackbar(v-model="snackbar" color="red" top)
                  | El archivo subido no es una imagen
                  template(v-slot:action="{ attrs }")
                    v-btn(color="white" text="" v-bind="attrs" @click="snackbar = false")
                      | Cerrar
                .xs12(class="inputGroupClass")
                  v-row.align-self-center
                    v-col(cols="12").align-self-center
                      v-row.align-self-center
                        input.d-none(ref="file" type="file" @change="handleImageUpload" accept="image/*")
                        v-card.mx-auto.mt-0.d-inline-flex.v-card--account(:class="selectedSubCat.pictures.imageInput1 ? 'success--text' : 'grey--text'" outlined="" height="106" width="106" @click="$refs.file.click()")
                          v-img(v-if="selectedSubCat.pictures.imageInput1" contain max-height='150px' name='image', :src='selectedSubCat.pictures.imageInput1')
                          v-icon.mx-auto(v-if="!selectedSubCat.pictures.imageInput1" size="96")
                            | mdi-file-image-outline
                      v-row.text-center.mt-3
                        v-col(cols="12").text-center
                          v-btn.picker-btn.align-self-center(width='150px' small rounded color='#00b6bd' @click="pickFile('imageInput1')") Cambiar imagen
                v-col
                  v-row
                    v-col(cols="4")
                      p Categoria principal
                    v-col(cols="8")
                      v-select(v-model="selectedSubCat.mainCategorie" :items="categories" item-text="data" item-value="data"  return-object label="Categoria" solo)
                  v-row
                    v-text-field( label='Nombre de la Subcategoria' :rules="[rules.nameRules]"  counter="100"  type="text", v-model='selectedSubCat.name')
                v-btn(dark link @click="cancel()") Cancelar
                v-btn(color='success', @click="save()" :disabled='!selectedSubCat.name || selectedSubCat.name.length > 100 || !selectedSubCat.mainCategorie' :loading='categoryLoading')
                  | GUARDAR
    v-row
      h2 Lista de subcategorias
    v-row(style=" align-items: baseline;")
        v-col.d-flex(cols="5")
          v-btn(color="primary" small @click="openCreateModal()") Crear categoria
          p.pr-2 Filtra por categoria principal
          v-select(v-model="selectedCat" :items="categories" item-text="data" clearable item-value="data" @change="filterSubCats()"  return-object label="Categoria" solo)
    v-row
      v-progress-linear(v-if="loading" indeterminate="" color="primary")
      v-data-table.elevation-1(:headers="headers" :search="search" :items="copySubcats" :items-per-page="15" style="width: 100%")
        template(v-slot:top)
            v-text-field.pl-2.pr-2( v-model="search" label="Buscar subcategoria")
        template(v-slot:item="{ item }" v-slot:scope="{ item }")
          tr(:key="item.id")
            td
              v-img.mx-auto(
                  contain
                  :src="getImage(item.pictures.imageInput1)"
                  height="65"
                  max-width="50"
                )
                template(v-slot:placeholder="")
                  v-row.fill-height.ma-0(align="center" justify="center")
                    v-progress-circular(indeterminate="" color="primary")
            td( v-text="item.name")
            td(v-text="item.mainCategorie.data")
            td
              v-btn( small text color='primary' @click="update(item)")
                | Actualizar
              v-btn( small text color='primary' @click="deleteCat(item)")
                  | Eliminar
</template>

<script>
  // import Swal from 'sweetalert2'
  import * as firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  import productPlaceHolder from '@/assets/icons/products.png'
  export default {
    components: {
    },
    data () {
      return {
        productPlaceHolder: productPlaceHolder,
        isCreate: false,
        rules: {
          nameRules: value => {
            return (!!value && value.length > 0 && value.length < 101) || 'Nombre de la subcategoria debe estar entre 0 y Maximo 100 caracteres'
          },
        },
        headers: [
          {
            text: 'Imagen',
            sortable: false,
            value: 'image',
          },
          { text: 'Nombre', value: 'name' },
          { text: 'Categoria principal', value: 'mainCategorie.data' },
          { text: 'Acciones', value: 'actions' },
        ],
        loading: false,
        subcats: [],
        copySubcats: [],
        search: '',
        categories: [],
        selectedCat: '',
        selectedSubCat: '',
        // added
        model: {
          name: null,
          pictures: {
            imageInput1: '',
          },
          mainCategorie: null,
        },
        createItemDialog: false,
        snackbar: false,
        categoryLoading: false,
      }
    },
    created () {
      const vm = this
      vm.loading = true
      vm.$store.dispatch('categories/getSubcategories').then(res => {
        vm.loading = false
        // console.log(res)
        if (res) {
          vm.subcats = res
          vm.copySubcats = res
        }
      })
      vm.$store.dispatch('shops/getMainCategories', 'en').then((res) => {
        if (res) {
          const categories = res.sort((a, b) => {
            if (a.data > b.data) {
              return 1
            }
            if (a.data < b.data) {
              return -1
            }
            return 0
          })
          vm.categories = categories
        }
      })
    },
    methods: {
      deleteCat (item) {
        const vm = this
        vm.loading = true
        vm.$store.dispatch('categories/deleteSubcategory', item).then(() => {
          // mostrar swal
          vm.loading = false
          const index = vm.subcats.findIndex(el => el.id === item.id)
          vm.subcats.splice(index, 1)
        })
      },
      filterSubCats () {
        const vm = this
        if (vm.selectedCat) {
          vm.copySubcats = vm.subcats.filter(el => el.mainCategorie.data === vm.selectedCat.data)
        } else {
          vm.copySubcats = vm.subcats
          vm.selectedCat = ''
        }
      },
      // added
      async handleImageUpload (event) {
        const vm = this
        const imageFile = event.target.files[0]
        if (imageFile.type.includes('image')) {
          // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
          // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

          const options = {
            maxSizeMB: 0.020,
            maxWidthOrHeight: 120,
            useWebWorker: true,
            maxIteration: 15,
          }
          try {
            const compressedFile = await imageCompression(imageFile, options)
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
            if (imageFile.size > compressedFile.size) {
              // console.log('compressed is smaller')
              await vm.uploadToServer(compressedFile)
            } else {
              // console.log('original is smaller')
              await vm.uploadToServer(imageFile)
            } // if original is smaller
          } catch (error) {
            // console.log(error)
          }
        } else {
          vm.snackbar = true
        }
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`subcategories/${vm.selectedCat.data}/`).push().key
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`subcategories/${vm.selectedCat.data}/${vm.model.id}/imageInput1`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            // console.log(url)
            vm.model.pictures.imageInput1 = url
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      pickFile (ref) {
        this.$refs[ref].click()
      },
      cancel () {
        const vm = this
        vm.model = {
          name: null,
          pictures: {
            imageInput1: '',
          },
          mainCategorie: null,
        }
        vm.createItemDialog = false
      },
      update (item) {
        const vm = this
        vm.createItemDialog = true
        vm.isCreate = false
        vm.selectedSubCat = item
        vm.selectedSubCat.oldMainCat = item.mainCategorie
      },
      openCreateModal () {
        const vm = this
        vm.createItemDialog = true
        vm.isCreate = true
        vm.selectedSubCat = vm.model
      },
      save (type) {
        const vm = this
        const itemData = vm.selectedSubCat
        vm.categoryLoading = true
        const data = {
          item: itemData,
          isCreate: vm.isCreate,
        }
        vm.$store.dispatch('categories/createUpdateSubcategory', data).then(() => {
          vm.categoryLoading = false
          vm.createItemDialog = false
          if (vm.isCreate) {
            vm.subcats.push(itemData)
          }
          vm.model = {
            name: null,
            pictures: {
              imageInput1: '',
            },
            mainCategorie: null,
          }
        })
      },
      getImage (url) {
        if (url === '') {
          return productPlaceHolder
        } else {
          return url
        }
      },
    },
  }
</script>
